import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconTrash } from '@calendly/ui/components/glyphs/IconTrash';
import { IconButton } from '@calendly/ui/components/icon-button';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
const cardCss = "c1bk3iz0";
const headerCss = "hhbl7cn";
const headerDetailsCss = "hc25uto";
const iconBadgeCss = "iud61ll";
const headerTextCss = "h1qmtjw4";
const bodyCss = "byw9318";
const footerCss = "f13mqe7m";
export const ConfigurableItemCard = ({
  icon,
  title,
  subtitle,
  onDelete,
  deleteLabel,
  deleteIcon = IconTrash,
  children,
  onCancel,
  onDone,
  isDoneDisabled = false,
  cancelLabel = I18n.t('publisher.action.cancel'),
  doneLabel = I18n.t('publisher.action.done')
}) => <div className={cardCss}>
    <div className={headerCss}>
      <div className={headerDetailsCss}>
        <span className={iconBadgeCss}>{icon}</span>
        <span className={headerTextCss}>
          <LabelText as="span" size="large">{title}</LabelText>
          {subtitle && <BodyText as="span" size="small" color="muted">{subtitle}</BodyText>}
        </span>
      </div>
      {onDelete && <IconButton appearance="ghost" size="small" icon={deleteIcon} title={deleteLabel} onClick={onDelete} />}
    </div>
    <div className={bodyCss}>{children}</div>
    <div className={footerCss}>
      <Button appearance="ghost" size="small" onClick={onCancel}>{cancelLabel}</Button>
      <Button appearance="primary" size="small" onClick={onDone} disabled={isDoneDisabled}>{doneLabel}</Button>
    </div>
  </div>;

require("./configurable_item_card.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./configurable_item_card.js");